import * as types from "../mutation-types";
import user from "@/api/user";

export const state = {
  signedIn: false,
  customerId: null,
  token: null,
};

export const getters = {
  signedIn: (state) => state.signedIn,
  token: (state) => state.token,
};

export const mutations = {
  [types.USER_AUTH_INITIALIZED](state, { signedIn, token }) {
    state.signedIn = signedIn;
    state.token = token;
  },

  [types.USER_SIGN_OUT](state) {
    state.signedIn = false;
    state.token = null;
  },
};

export const actions = {
  async authenticate({ commit, rootGetters }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      // eslint-disable-next-line no-unused-vars
      const { token } = await user.authenticate(
        rootGetters["google/idToken"]
      );

      commit(types.USER_AUTH_INITIALIZED, { signedIn: !!token, token: token });
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async userSignOut({ commit }) {
    await commit(types.USER_SIGN_OUT);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
